module.exports = __webpack_public_path__ + "img/3-grayscale.c85c045.png";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets/3-grayscale.png
// module id = YdZt
// module chunks = 1